import React from 'react';

const verticals = [
  {
    icon: '🏸', title: 'Padel & Sport', tag: 'RÉSERVATION',
    tagColor: '#7C3AED', bg: 'rgba(61,26,110,0.35)',
    desc: 'Réservations en ligne, planning des terrains, abonnements membres et galerie photos pour clubs de padel et salles de sport.',
  },
  {
    icon: '🖥️', title: 'Coworking', tag: 'SHOWCASE',
    tagColor: '#2563EB', bg: 'rgba(29,53,87,0.35)',
    desc: 'Présentation des espaces, tarifs, tour virtuel, formulaire de visite et système de réservation de bureaux à la demande.',
  },
  {
    icon: '☕', title: 'Café & Lounge', tag: 'MENU DIGITAL',
    tagColor: '#92400E', bg: 'rgba(92,40,14,0.35)',
    desc: 'Menu digital, ambiance en images, événements, commande en ligne et fidélisation client pour cafés et bars à tendance.',
  },
  {
    icon: '💆', title: 'Hammam & Spa', tag: 'RENDEZ-VOUS',
    tagColor: '#065F46', bg: 'rgba(6,78,59,0.3)',
    desc: 'Réservation de soins, présentation des rituels, espace bien-être premium et prise de rendez-vous en ligne 24h/24.',
  },
  {
    icon: '💪', title: 'Salle de sport', tag: 'MEMBRES',
    tagColor: '#7C3AED', bg: 'rgba(61,26,110,0.25)',
    desc: 'Abonnements en ligne, planning des cours, coaches, galerie transformation et accès espace membres sécurisé.',
  },
  {
    icon: '🛒', title: 'E-commerce', tag: 'PAIEMENT',
    tagColor: '#9F1239', bg: 'rgba(127,29,29,0.3)',
    desc: 'Boutique en ligne complète avec paiement intégré, gestion stock, paniers abandonnés et tunnel de conversion optimisé.',
  },
];

export default function Verticals() {
  return (
    <section id="verticals" style={{
      background: '#0a0a0f', padding: '7rem 2rem',
    }}>
      <div style={{ maxWidth: 1200, margin: '0 auto' }}>
        <div style={{ textAlign: 'center', marginBottom: '4rem' }}>
          <p style={{
            color: '#7C3AED', fontWeight: 600, fontSize: 12,
            letterSpacing: '0.15em', textTransform: 'uppercase',
            marginBottom: '1rem',
          }}>NOS VERTICALES</p>
          <h2 style={{
            fontFamily: 'Plus Jakarta Sans, sans-serif', fontWeight: 800,
            fontSize: 'clamp(2rem, 5vw, 3.5rem)',
            lineHeight: 1.1, letterSpacing: '-0.02em',
          }}>
            Ce qu'on <span style={{ color: '#A78BFA' }}>construit</span>
          </h2>
          <p style={{ color: '#8b8b9a', marginTop: '1rem', fontSize: 16, maxWidth: 500, margin: '1rem auto 0' }}>
            Des sites pensés pour votre secteur, avec les fonctionnalités qui convertissent vraiment.
          </p>
        </div>

        <div style={{
          display: 'grid',
          gridTemplateColumns: 'repeat(auto-fit, minmax(320px, 1fr))',
          gap: '1.2rem',
        }}>
          {verticals.map((v, i) => (
            <div key={i} style={{
              background: v.bg,
              border: '1px solid rgba(255,255,255,0.07)',
              borderRadius: 16, padding: '2rem',
              transition: 'all 0.3s', cursor: 'default',
              position: 'relative',
            }}
              onMouseEnter={e => {
                e.currentTarget.style.transform = 'translateY(-4px)';
                e.currentTarget.style.borderColor = 'rgba(124,58,237,0.3)';
              }}
              onMouseLeave={e => {
                e.currentTarget.style.transform = 'translateY(0)';
                e.currentTarget.style.borderColor = 'rgba(255,255,255,0.07)';
              }}
            >
              {/* Tag */}
              <div style={{
                position: 'absolute', top: '1.2rem', right: '1.2rem',
                background: 'rgba(0,0,0,0.4)',
                border: `1px solid ${v.tagColor}40`,
                borderRadius: 20, padding: '3px 10px',
                fontSize: 10, fontWeight: 600,
                color: v.tagColor, letterSpacing: '0.08em',
              }}>{v.tag}</div>

              <div style={{ fontSize: 32, marginBottom: '1rem' }}>{v.icon}</div>
              <h3 style={{
                fontFamily: 'Plus Jakarta Sans, sans-serif', fontSize: '1.15rem',
                fontWeight: 700, marginBottom: '0.75rem',
              }}>{v.title}</h3>
              <p style={{ color: '#8b8b9a', fontSize: 14, lineHeight: 1.7, marginBottom: '1.2rem' }}>
                {v.desc}
              </p>
              <a href="#contact" style={{
                color: '#A78BFA', fontSize: 14, fontWeight: 500,
                textDecoration: 'none', display: 'inline-flex',
                alignItems: 'center', gap: 6,
                transition: 'gap 0.2s',
              }}
                onMouseEnter={e => e.currentTarget.style.gap = '10px'}
                onMouseLeave={e => e.currentTarget.style.gap = '6px'}
              >Voir exemple →</a>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
